module.exports = __webpack_public_path__ + "components/country-flag/static/cy-6cd6852e88d19b6c97822fd7913f3eb2.svg";